import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TicketsPage from "./components/TicketsPage";
import DynamicPage from "./components/DynamicPage";
import TrailerPage from "./components/TrailerPage";
import AvisoLegalPage from "./pages/AvisoLegalPage";
import PoliticaPrivacidadPage from "./pages/PoliticaPrivacidadPage";
import PoliticaCookiesPage from "./pages/PoliticaCookiesPage";
import CookieBanner from "./components/CookieBanner";
import GoogleAnalytics from "./components/GoogleAnalytics";
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminMovie from "./components/admin/AdminMovie";
import AdminMedia from "./components/admin/AdminMedia";
import AdminTrailer from "./components/admin/AdminTrailer";
import AdminPages from "./components/admin/AdminPages";
import AdminSiteConfig from "./components/admin/AdminSiteConfig";
import AdminCinemas from "./components/admin/AdminCinemas";
import AdminSessions from "./components/admin/AdminSessions";
import AdminSettings from "./components/admin/AdminSettings";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function HomeRouter() {
  const [homePage, setHomePage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/site-config`)
      .then(r => r.json())
      .then(d => setHomePage(d.homePage || 'entradas'))
      .catch(() => setHomePage('entradas'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a2b3c] flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-[#50c878] border-t-transparent rounded-full" />
      </div>
    );
  }

  if (homePage === 'entradas') return <TicketsPage isHomePage />;
  if (homePage === 'trailer') return <TrailerPage isHomePage />;
  return <Navigate to={`/page/${homePage}`} replace state={{ isHomePage: true }} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomeRouter />} />
          <Route path="/entradas" element={<TicketsPage />} />
          <Route path="/tickets" element={<TicketsPage />} />
          <Route path="/trailer" element={<TrailerPage />} />
          <Route path="/page/:slug" element={<DynamicPage />} />
          
          {/* Legacy routes redirect to dynamic pages */}
          <Route path="/presentacion" element={<Navigate to="/page/presentacion" replace />} />
          <Route path="/sinopsis" element={<Navigate to="/page/sinopsis" replace />} />
          <Route path="/ficha" element={<Navigate to="/page/ficha" replace />} />
          <Route path="/sobre-la-pelicula" element={<Navigate to="/page/sobre-la-pelicula" replace />} />
          
          {/* Legal Pages */}
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
          <Route path="/politica-cookies" element={<PoliticaCookiesPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="pages" element={<AdminPages />} />
            <Route path="site-config" element={<AdminSiteConfig />} />
            <Route path="movie" element={<AdminMovie />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="trailer" element={<AdminTrailer />} />
            <Route path="cinemas" element={<AdminCinemas />} />
            <Route path="sessions" element={<AdminSessions />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
